import * as React from 'react';
import Msg from '../../localization/Msg';
import { Str } from '../../localization/translationKeys';
import { downloadURL } from './module';
import { btnStyle } from '../../forms/styles/button';
import { COLORS } from '../../globalStyle/colors';
import { Link } from 'react-router-dom';
import LocalBtn from '../../localization/LocalBtn';
import { Report } from './models';
import { css } from '@emotion/core';
import { isNilOrEmpty } from '../../language/module';


const styles = {
  cells:    {
    reports:   css`
      min-width: 200px;
    `,
    delivered: css`
      min-width: 130px;
    `,
    language:  css`
      min-width: 125px;
    `,
    type:      css`
      min-width: 50px;
    `,
    navBtn:    css`
      min-width: 145px;
      padding: 5px !important;
    `,
  },
  link:     css`
    display: block;
    margin-left: 5px;
    margin-right: 5px;
  `,
  disabled: css`
    cursor: default;
    opacity: .6;

    &:hover {
      text-decoration: none;
      cursor: default;
    }
  `,
};


type Props = {
  report: Report;
  language: string;
  code: string;

  showShareScoresBtn: boolean;
  showDownloadReportBtn: boolean;

  setReport: () => void;
  onClickShareScoresBtn: () => void;

  className?: string;
};

const reportType = (report: Report) => (
  report.reportTypeMessageKey !== 'Portal-AggregateReport'
  ? <Msg str={report.reportTypeMessageKey} />
  : isNilOrEmpty(report.groupReportTitle)
    ? <Msg str={report.reportTypeMessageKey} />
    : <span>{report.groupReportTitle}</span>
);

/**
 * FeedbackReportTableRow: a component that renders an individual row/report item in the feedback report table.
 */
const FeedbackReportTableRow: React.FC<Props> = (
  {
    report,
    language,
    code,
    showShareScoresBtn,
    showDownloadReportBtn,
    setReport,
    onClickShareScoresBtn,
    className,
  },
) => (
  <tr key={`${report.releaseId}|${report.reportTypeMessageKey}`}>
    <td css={styles.cells.reports}>{reportType(report)}</td>
    <td css={styles.cells.delivered}>
      {new Date(report.effectiveDate).toLocaleDateString(code)}
    </td>
    <td css={styles.cells.language}>
      {language}
    </td>
    <td css={styles.cells.navBtn}>
      {
        showDownloadReportBtn
          ? (
            <a
              href={downloadURL(report)}
              css={[btnStyle.primary(COLORS.BLUE), styles.link, !report.fileExists && styles.disabled]}
              target={'_blank'}
              rel='noopener noreferrer'
            >
              <Msg str={Str.Download} />
            </a>
          )
          : (
            <Link
              to='#'
              css={[btnStyle.primary(COLORS.BLUE), styles.link]}
              onClick={setReport}
            >
              <Msg str={Str.ViewReport} />
            </Link>
          )
      }
    </td>
    {
      showShareScoresBtn && (
        <td css={styles.cells.navBtn}>
          <LocalBtn
            str={Str.ShareScores}
            css={[btnStyle.transparent(COLORS.DARK_GREY)]}
            onClick={onClickShareScoresBtn}
          />
        </td>
      )
    }
  </tr>
);

export default FeedbackReportTableRow;
